import { availabilityEntryPoint } from '@jira/spa-apps__servicedesk-availability/src/availabilityEntryPoint.entrypoint.tsx';
import { availabilityRoute } from '@jira/router-routes__servicedesk-availability-routes/src/availabilityRoute.tsx';
import { PageSkeleton } from '@jira/spa-apps__servicedesk-availability/src/PageSkeleton.tsx';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { routingOnboardingFinishedResource } from '@jira/router-resources__service-desk-routing/src/routingSetupStatusResource.tsx';
import ErrorPagesNotFound from '@jira/router-routes__common/src/ui/error-pages/not-found/index.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import {
	getServiceDeskNavigationResources,
	getServicedeskPageContextResources,
} from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { isFeatureEnabled } from '@atlassiansox/frontend-feature-encoding';
// eslint-disable-next-line jira/restricted/@jira+servicedesk__common-toPackageName
import { APP_NAMES, toPackageName } from '@jira/servicedesk__common/src/toPackageName.tsx';
import type { Route } from '@atlassian/react-resource-router';

const isWorkforceAemEnabled = (): boolean =>
	fg('jsm_workforce_use_aem') ? isFeatureEnabled('jira-service-management', 'jsm-workforce') : true;

const entryPoint = createPageEntryPoint({ main: availabilityEntryPoint });

export const availabilityRouteEntry: Route = createEntry(availabilityRoute, () => ({
	group: 'servicedesk',
	// eslint-disable-next-line no-restricted-syntax
	component: ErrorPagesNotFound,
	layout: serviceProjectLayout,
	skeleton: PageSkeleton,
	ufoName: 'jsm-availability',

	navigation: {
		menuId: MenuIdProjects,
	},

	forPaint: [LazyAtlassianNavigation],

	resources: [
		routingOnboardingFinishedResource,
		...getServiceDeskNavigationResources(),
		...getServicedeskPageContextResources(),
		getConsolidationStateResource(),
	],

	entryPoint: () => {
		if (!isWorkforceAemEnabled() || !fg('jsm_workforce_optimization_main')) {
			return undefined;
		}
		return entryPoint;
	},

	supportsPreviewPanel: true,

	bifrost: {
		bifrostGroup: 'shell-only',
	},

	meta: {
		reporting: {
			id: APP_NAMES.AVAILABILITY,
			packageName: toPackageName(APP_NAMES.AVAILABILITY),
			teamName: 'jsd-shield',
		},
	},
}));
